module.exports = __webpack_public_path__ + "static/media/22ESCWA9.ca146b50.jpg";